import { faFunction } from "@fortawesome/pro-duotone-svg-icons";
import { Icon } from "@progress/kendo-react-common";
import {
  InputClearValue,
  InputPrefix,
  InputSeparator,
  TextBox,
} from "@progress/kendo-react-inputs";
import { isGalleryEditor } from "../../Template/NewTemplateSignals";
import { expressionBuilderVisibility } from "../Store/CommonSignals";
import { ColorChangingIcon } from "../UI/ColorChangingIcon";

const ExpressionBuilderPrefix = (_isGalleryEditor) => {
  return (
    <>
      <InputPrefix>
        <ColorChangingIcon
          icon={faFunction}
          initialPrimaryColor="#605e5c"
          initialSecondaryColor="#0078D4"
          margin="0 5px 0 10px"
          onClick={() => {
            expressionBuilderVisibility.value = true;
            isGalleryEditor.value = _isGalleryEditor;
          }}
        />
      </InputPrefix>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
    </>
  );
};

const ExpressionBuilderSuffix = ({ handlePropertyChange }) => {
  return (
    <>
      <InputSeparator
        style={{
          width: "1px",
          backgroundColor: "gainsboro",
          margin: "4px 0px",
        }}
      />
      <InputClearValue
        onClick={() => handlePropertyChange({ propName: "Expression", propValue: "" })}
      >
        <Icon name="x" />
      </InputClearValue>
    </>
  );
};

export const CalculatedFieldInput = ({ handlePropertyChange, defaultValue, isGalleryEditor }) => {
  return (
    <TextBox
      name={"Expression"}
      label={"Expression"}
      placeholder="Build the calculated expression"
      value={defaultValue}
      readOnly={true}
      prefix={() => ExpressionBuilderPrefix(isGalleryEditor)}
      suffix={() =>
        ExpressionBuilderSuffix({
          handlePropertyChange,
        })
      }
    />
  );
};

export default CalculatedFieldInput;
